import { Star, StarHalf } from "lucide-react";

export default function StarRating({ value = 0, size = "md", showValue = true, className = "" }) {
    const sz = size === "sm" ? "h-3.5 w-3.5" : size === "lg" ? "h-5 w-5" : "h-4 w-4";
    const full = Math.floor(value);
    const hasHalf = value - full >= 0.25 && value - full < 0.75;
    const totalFilled = value - full >= 0.75 ? full + 1 : full;
    const stars = [];
    for (let i = 0; i < 5; i++) {
        if (i < totalFilled) {
            stars.push(<Star key={i} className={`${sz} text-yellow-400 fill-yellow-400`} />);
        } else if (i === totalFilled && hasHalf) {
            stars.push(<StarHalf key={i} className={`${sz} text-yellow-400 fill-yellow-400`} />);
        } else {
            stars.push(<Star key={i} className={`${sz} text-zinc-700`} />);
        }
    }
    return (
        <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="star-rating">
            <div className="inline-flex items-center gap-0.5">{stars}</div>
            {showValue && <span className="text-sm text-zinc-300 font-medium tabular-nums">{value.toFixed(1)}</span>}
        </div>
    );
}
